import React, {Fragment, useState} from 'react';
import {Tag, Icon} from '@blueprintjs/core';

import {Row, Cell} from '/src/components/tables/table'


const ItemRow = ({
  area,
  areaContext,
  beginEditingItem,
  deleteContext,
  setShapeHighlight
}) => {
    const [showButtons, setShowButtons] = useState(false);

    return (
            <Row
                key={areaContext.id}
                $hoverColor="#d7e4f7"
                onMouseOver={() => {
                    setShowButtons(true);
                    if (!!area) setShapeHighlight(area, true);
                }}
                onMouseLeave={() => {
                    setShowButtons(false);
                    if (!!area) setShapeHighlight(area, false);
                }}
            >
                <Cell span={2} halign="center" valign="center">
                    <Tag>{areaContext.type}</Tag>
                </Cell>
                <Cell span={2} halign="center" valign="center">
                    <Tag intent="primary">{areaContext.areaId}</Tag>
                </Cell>
                <Cell span={3} halign="center" valign="center">
                    {areaContext.type === "taxonomy" && areaContext.taxonomy && <Tag>{areaContext.taxonomy}</Tag>}
                </Cell>
                <Cell span={1} halign="right" valign="center" gap="10px">
                    {showButtons && (
                        <Fragment>
                            <Icon
                                icon="edit"
                                htmlTitle="Edit"
                                intent="success"
                                onClick={() => beginEditingItem(areaContext)}
                            />
                            <Icon
                                icon="trash"
                                htmlTitle="Delete"
                                intent="danger"
                                onClick={() => deleteContext(areaContext)}
                            />
                        </Fragment>
                    )}
                </Cell>
            </Row>
        )
}

export default ItemRow;
